// Usage options
export const usageOptions = [
    { value: '0', label: '-- none --' },
    { value: '1', label: 'Speed' },
    { value: '2', label: 'Current battery' },
    { value: '3', label: 'Voltage lowest' },
    { value: '4', label: 'Voltage filtered (no used for VESC)' },
    { value: '5', label: 'Autonomy %' },
    { value: '6', label: 'Autonomy Km' },
    { value: '7', label: 'Power max W' },
    { value: '8', label: 'Motor master temperature' },
    { value: '9', label: 'Motor slave temperature' },
    { value: '10', label: 'Power max kW' },
    { value: '11', label: 'ESC master temperature' },
    { value: '12', label: 'ESC slave temperature' },
    { value: '13', label: 'Mode' },
    { value: '14', label: 'Speed max' },
    { value: '15', label: 'Trip' },
    { value: '16', label: 'ODO' },
    { value: '17', label: 'Power W' },
    { value: '18', label: 'Power KW' },
    { value: '19', label: 'Nav remaining distance' },
    { value: '20', label: 'Nav intersection distance' },
    { value: '21', label: 'Cruise speed conditional' },
    { value: '22', label: 'TPMS1 Pressure' },
    { value: '23', label: 'TPMS2 Pressure' },
    { value: '24', label: 'ESC current master in' },
    { value: '25', label: 'ESC  current slave in' },
    { value: '26', label: 'MAINTENANCE : Button 1 status' },
    { value: '27', label: 'MAINTENANCE : Button 2 status' },
    { value: '28', label: 'MAINTENANCE : Button pwr status' },
    { value: '29', label: 'MAINTENANCE : Relay output status' },
    { value: '30', label: 'MAINTENANCE : CAN RX' },
    { value: '31', label: 'MAINTENANCE : UART RX' },
    { value: '32', label: 'MAINTENANCE : Error bytes' },
    { value: '33', label: 'MAINTENANCE : throttle ADC input' },
    { value: '34', label: 'MAINTENANCE : brake ADC input' },
    { value: '35', label: 'MAINTENANCE : DAC output' },
    { value: '36', label: 'Voltage unfiltered' },
    { value: '37', label: 'Throttle %' },
    { value: '38', label: 'Brake %' },
    { value: '39', label: 'ESC master phase curent A' },
    { value: '40', label: 'ESC slave phase curent A' },
    { value: '41', label: 'ESC master erpm' },
    { value: '42', label: 'ESC slave erpm' },
    { value: '43', label: 'Speed GPS / EB6' },
    { value: '44', label: 'ESCs highest of temperatures' },
    { value: '45', label: 'Motors highest of temperatures' },

    // Add more options if needed
];


export const themeTypeOptions = [
    { value: '0', label: 'Ride' },
    { value: '1', label: 'Navigation' },
    { value: '2', label: 'Bootstrap' },
    { value: '3', label: 'Throttles Calibration' },
    { value: '4', label: 'Tech1' },
    { value: '5', label: 'Tech2' },
    { value: '6', label: 'Tech3' },
]

export const getThemeTypeLabelFromValue = (value) => {
    const option = themeTypeOptions.find((option) => option.value === value);
    return option ? option.label : 'Unknown';
}


export const barUsageOptions = [
    { value: '0', label: 'Speed' },
    { value: '1', label: 'Power' },
    { value: '2', label: 'BMS internal' },
    { value: '3', label: 'BMS cells temperature' },
    { value: '4', label: 'ESCs highest of both temperatures' },
    { value: '5', label: 'ESC master temperature' },
    { value: '6', label: 'ESC slave temperature' },
    { value: '7', label: 'Motors highest of both temperatures' },
    { value: '8', label: 'Motor master temperature' },
    { value: '9', label: 'Motor slave temperature' },
    { value: '10', label: 'Duty master' },
    { value: '11', label: 'Duty slave' },
    { value: '12', label: 'Autonomy' },
]


// Usage options
export const specialIndicatorUsageOptions = [
    { value: '0', label: 'Eco Mode' },
    { value: '1', label: 'Nitro' },
    { value: '2', label: 'Accel Mode' },
];
